import { useState, useEffect } from "react";
import { ArrowRight, ChevronDown } from "lucide-react";

const HeroCarousel = () => {
  const images = [
    "/images/img1.jpg",
    "/images/IMG2.jpg",
    "/images/img3.jpg"
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [images.length]);

  const scrollToProducts = () => {
    const element = document.getElementById("products");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="relative h-screen w-full overflow-hidden bg-primary">
      {/* Background Slideshow */}
      {images.map((src, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentImage ? "opacity-40" : "opacity-0"
            }`}
        >
          <img
            src={src}
            alt={`Industrial Background ${index + 1}`}
            className="w-full h-full object-cover"
          />
        </div>
      ))}

      {/* Overlay Gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/50 to-transparent" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <span className="inline-block py-1 px-3 rounded-full bg-white/10 border border-white/20 text-white text-sm font-semibold tracking-wide mb-6 animate-fade-in uppercase">
          Established 1996
        </span>
        <h1 className="text-4xl sm:text-6xl md:text-7xl font-bold font-heading text-white tracking-tight mb-6 animate-slide-up">
          Built on Trust. <br className="hidden sm:block" />
          <span>
            Powered by Precision.
          </span>
        </h1>
        <p className="text-lg sm:text-xl text-white max-w-2xl mx-auto mb-10 animate-slide-up animation-delay-200">
          Uma Ispat is a premier iron and steel trading company, delivering high-quality materials and fabrication solutions across India.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 animate-slide-up animation-delay-400">
          <button
            onClick={scrollToProducts}
            className="bg-accent hover:bg-blue-700 text-white px-8 py-4 rounded-full font-medium text-lg transition-all shadow-lg hover:shadow-accent/50 flex items-center justify-center gap-2 group"
          >
            Explore Products
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="#contact"
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-full font-medium text-lg transition-all flex items-center justify-center"
          >
            Contact Us
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white/50 w-8 h-8" />
      </div>
    </div>
  );
};

export default HeroCarousel;
